module.exports = __webpack_public_path__ + "media/images/pc/items/gift/kiribako_04-ca5404dd2b2673eeb2adfb09f7045f1f.jpg";